import { useMutation } from '@tanstack/react-query';
import { PatientDocument } from 'src/models';
import { ambientApi } from 'src/services';

export type UseCreatePatientDocumentPayload = {
  source: PatientDocument['source'];
  description?: string;
} & (
  | {
      type: 'file';
      file: File;
      mime_type?: string;
      size?: number;
    }
  | {
      type: 'text';
      content: string;
    }
);

export type CreatePatientDocumentResponse = PatientDocument;

export const useCreatePatientDocument = () => {
  return useMutation({
    mutationFn: (payload: UseCreatePatientDocumentPayload) => {
      const { file, ...rest } = payload as PatientDocument & { file: File };
      const formData = new FormData();
      Object.entries(rest).forEach(([key, value]) => {
        formData.append(key, value as string);
      });
      if (file) {
        formData.append('file', file);
      }
      return ambientApi
        .post<CreatePatientDocumentResponse>(`patient_document`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(({ data }) => data);
    },
  });
};
